<template>
  <div id="cancel" class="box-xs hidden bg-white rounded-4 p-3">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="text-semiBold">Detail Karyawan</div>
      <button class="btn close-popup p-0" type="button"><span class="icon-ico-close"></span></button>
    </div>
    <div class="content-popup">
      <div class="d-flex justify-content-between align-items-center">
        <div class="col-auto d-flex align-items-center">
          <img :src="data.profile.photo ? data.profile.photo : '/img/user-default.jpg'" class="karyawan">
          <div class="text-sm text-medium text-hidden ps-2">{{ data.profile.fullName }}</div>
        </div>
        <div class="status text-xs text-medium" 
          :class="'bg-light' + employeeRoleColor(data.roleId) + ' color-dark' + employeeRoleColor(data.roleId)">{{ employeeRoleText(data.roleId )}}</div>
      </div>
      <hr>
      <div class="d-flex justify-content-between align-items-center mb-2">
        <div class="text-xs color-gray-80">Nomor Telepon</div>
        <div class="text-xs text-medium">{{ data.profile.phone }}</div>
      </div>
      <div class="d-flex justify-content-between align-items-center mb-2">
        <div class="text-xs color-gray-80">Jenis Kelamin</div>
        <div class="text-xs text-medium">{{ genderText(data.profile.gender) }}</div>
      </div>
      <div class="d-flex justify-content-between align-items-center mb-2">
        <div class="text-xs color-gray-80 align-self-baseline">Alamat</div>
        <div class="text-xs col-6 text-right text-medium">{{ data.profile.address }}</div>
      </div>
      <div class="d-flex justify-content-between align-items-center mb-2">
        <div class="text-xs color-gray-80">Email</div>
        <div class="text-xs text-medium">{{ data.email }}</div>
      </div>
      <!-- <div class="d-flex justify-content-between align-items-center mb-2">
        <div class="text-xs color-gray-80">Kata Sandi App</div>
        <div class="text-xs text-medium">9999999999</div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  props: ['data']
}
</script>